import { i18nMark } from 'lingui-react';

const messages = {
  pdfLink: i18nMark('PDF Link'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/PdfLink/messages.js